(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-bundle-builder"] && !Shopify.designMode) return;
  try {
    
class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.minProducts = parseInt(this.dataset.minProducts);
    this.maxProducts = parseInt(this.dataset.maxProducts);
    this.selectedProducts = [];
    this.bundleButton = this.querySelector('.bundle-add-to-cart');
    this.totalPriceElement = this.querySelector('.bundle-total-price');
    this.originalTotalPriceElement = this.querySelector('.bundle-original-total-price');
    this.discountTextElement = this.querySelector('.bundle-discount-text');
    
    this.initEventListeners();
    this.updateUI();
  }

  initEventListeners() {
    this.querySelectorAll('.bundle-product-select').forEach(checkbox => {
      checkbox.addEventListener('change', this.handleProductSelect.bind(this));
    });
    
    if (this.bundleButton) {
      this.bundleButton.addEventListener('click', this.addBundleToCart.bind(this));
    }
  }

  handleProductSelect(event) {
    const checkbox = event.target;
    const productId = checkbox.value;
    const productElement = checkbox.closest('.bundle-product');
    const variantId = productElement.dataset.variantId;
    const price = parseFloat(productElement.dataset.price);

    if (checkbox.checked) {
      if (this.selectedProducts.length >= this.maxProducts) {
        checkbox.checked = false;
        return;
      }
      this.selectedProducts.push({ id: productId, variantId, price });
    } else {
      this.selectedProducts = this.selectedProducts.filter(product => product.id !== productId);
    }

    this.updateUI();
  }

  updateUI() {
    const totalItems = this.selectedProducts.length;
    const totalPrice = this.selectedProducts.reduce((sum, product) => sum + product.price, 0);
    const discountedPrice = totalPrice * 0.8; // 20% discount
    
    // Update counters
    this.querySelector('.bundle-counter').textContent = `${totalItems}/${this.maxProducts}`;
    
    // Update price display
    if (this.totalPriceElement) {
      this.totalPriceElement.textContent = Shopify.formatMoney(discountedPrice, theme.moneyFormat);
    }
    if (this.originalTotalPriceElement && totalItems > 0) {
      this.originalTotalPriceElement.textContent = Shopify.formatMoney(totalPrice, theme.moneyFormat);
      this.originalTotalPriceElement.style.display = 'block';
    } else if (this.originalTotalPriceElement) {
      this.originalTotalPriceElement.style.display = 'none';
    }
    
    // Update button state
    if (this.bundleButton) {
      this.bundleButton.disabled = totalItems < this.minProducts;
      this.bundleButton.textContent = totalItems < this.minProducts 
        ? `Select ${this.minProducts - totalItems} more to bundle` 
        : 'Add Bundle to Cart';
    }
  }

  async addBundleToCart() {
    if (this.selectedProducts.length < this.minProducts) return;
    
    const items = this.selectedProducts.map(product => ({
      id: product.variantId,
      quantity: 1,
      properties: {
        'Bundle Item': 'Yes'
      }
    }));
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        window.location.href = '/cart';
      } else {
        console.error('Error adding to cart:', await response.json());
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
}

customElements.define('bundle-builder', BundleBuilder);

  } catch(e) { console.error(e); }
})();
})();
